import { render, staticRenderFns } from "./ContactCreate.vue?vue&type=template&id=13d988e0&scoped=true"
import script from "./ContactCreate.vue?vue&type=script&lang=js"
export * from "./ContactCreate.vue?vue&type=script&lang=js"
import style0 from "./ContactCreate.vue?vue&type=style&index=0&id=13d988e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d988e0",
  null
  
)

export default component.exports